/**
* Dtails+ Accept terms and conditions
*/
import { Drawer } from "theme";
import { animate } from "vendor";

function fnDtailsCartTerms(event, action, status) {
  var cartTerms = event.closest('form').querySelector('dtails-cart-terms');
  if (cartTerms) {
    var cartTermsDrawer = cartTerms.querySelector('[data-dtails-cart-terms-drawer]'),
        orderRecap = document.querySelector('.cart-order__recap');
    if (action == 'open') {
      cartTermsDrawer.classList.add('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "relative";
    } else if (action == 'close') {
      cartTermsDrawer.classList.remove('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "sticky";
    }

    if (status == 'accept') {
      var cartTermsDrawerCheckbox = cartTerms.querySelector('[data-dtails-cart-terms-checkbox]');
      if (cartTermsDrawerCheckbox) cartTermsDrawerCheckbox.checked = true;
      localStorage.setItem('theme:cart-terms-accepted', 'true');
    }
  }
}

var DtailsCartTerms = class extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('submit', this._onSubmit);
    this.addEventListener("click", this._onClick);
    if (localStorage.getItem('theme:cart-terms-accepted') == 'true' ) {
      fnDtailsCartTerms(this, '', 'accept');
    }
  }

  _onClick(event) {
    if (event.target.closest('[data-dtails-cart-terms-drawer-link]')) {
      fnDtailsCartTerms(event.target, 'open');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-drawer-close]')) {
      fnDtailsCartTerms(event.target, 'close');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-accept-button]')) {
      fnDtailsCartTerms(event.target, 'close', 'accept');
      event.preventDefault();
    } else {
      return;
    }
  }

  _onSubmit(event) {
    const submit = event.target.querySelector('button');
    const termsCartTerms = submit.closest('form').querySelector('dtails-cart-terms');
    if (!termsCartTerms) return;

    const termsCheckbox = termsCartTerms.querySelector('[data-dtails-cart-terms-checkbox]');

    if (submit.getAttribute('name') === 'checkout' && termsCheckbox) {
      if (termsCheckbox.checked) {
        localStorage.setItem('theme:cart-terms-accepted', 'true');
      } else {
        fnDtailsCartTerms(event.target, 'open');
        submit.setAttribute("aria-busy", "false");
        event.preventDefault();
        return false;
      }
    }
  }

};
if (!window.customElements.get("dtails-cart-terms") && window.themeVariables.settings.dtailsCartTerms) {
  window.customElements.define("dtails-cart-terms", DtailsCartTerms);
}

/**
 * Centered newsletter modal with fade in/out (no slide drawer animation).
 */
class NewsletterModal extends Drawer {
  _setInitialPosition() {
    this.style.left = "50%";
    this.style.right = "auto";
    this.style.top = "50%";
    this.style.bottom = "auto";
  }

  _showTransition(shouldAnimate = true) {
    this._setInitialPosition();

    const content = this.shadowRoot.querySelector('[part="content"]');
    const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    const animationControls = animate(
      this,
      { opacity: [0, 1], visibility: ["hidden", "visible"] },
      { duration: 0.25, easing: "ease" }
    );

    if (content) {
      animate(
        content,
        { opacity: [0, 1], transform: ["scale(0.96)", "scale(1)"] },
        { duration: 0.25, easing: [0.25, 0.1, 0.25, 1] }
      );
    }

    if (closeButton) {
      animate(closeButton, { opacity: [0, 1] }, { duration: 0.2 });
    }

    shouldAnimate ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }

  _hideTransition() {
    const content = this.shadowRoot.querySelector('[part="content"]');
    const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');

    if (closeButton) {
      animate(closeButton, { opacity: [null, 0] }, { duration: 0.15 });
    }

    if (content) {
      animate(
        content,
        { opacity: [null, 0], transform: ["scale(1)", "scale(0.96)"] },
        { duration: 0.2, easing: "ease" }
      );
    }

    const animationControls = animate(
      this,
      { opacity: [1, 0], visibility: ["visible", "hidden"] },
      { duration: 0.2, easing: "ease" }
    );

    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
}

if (!window.customElements.get("newsletter-modal")) {
  window.customElements.define("newsletter-modal", NewsletterModal);
}

/**
 * Centered legal-guarantee popup with zoom in/out (no drawer slide).
 */
class LegalGuaranteePopup extends Drawer {
  // AI_PENDING_REVIEW
  _setInitialPosition() {
    this.style.top = "0px";
    this.style.right = "0px";
    this.style.bottom = "0px";
    this.style.left = "0px";
  }

  // AI_PENDING_REVIEW
  _showTransition(shouldAnimate = true) {
    this._setInitialPosition();

    const content = this.shadowRoot.querySelector('[part="content"]');
    const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    const animationControls = animate(
      this,
      { opacity: [0, 1], visibility: ["hidden", "visible"] },
      { duration: 0.25, easing: "ease" }
    );

    if (content) {
      animate(
        content,
        { opacity: [0, 1], transform: ["scale(0.85)", "scale(1)"] },
        { duration: 0.3, easing: [0.16, 1, 0.3, 1] }
      );
    }

    if (closeButton) {
      animate(closeButton, { opacity: [0, 1] }, { duration: 0.2 });
    }

    shouldAnimate ? animationControls.play() : animationControls.finish();
    return animationControls.finished.then(() => this.classList.add("show-close-cursor"));
  }

  // AI_PENDING_REVIEW
  _hideTransition() {
    const content = this.shadowRoot.querySelector('[part="content"]');
    const closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');

    if (closeButton) {
      animate(closeButton, { opacity: [null, 0] }, { duration: 0.15 });
    }

    if (content) {
      animate(
        content,
        { opacity: [null, 0], transform: ["scale(1)", "scale(0.85)"] },
        { duration: 0.22, easing: "ease" }
      );
    }

    const animationControls = animate(
      this,
      { opacity: [1, 0], visibility: ["visible", "hidden"] },
      { duration: 0.2, easing: "ease" }
    );

    return animationControls.finished.then(() => this.classList.remove("show-close-cursor"));
  }
}

if (!window.customElements.get("legal-guarantee-popup")) {
  window.customElements.define("legal-guarantee-popup", LegalGuaranteePopup);
}

/**
 * Tag Klaviyo popup forms so theme CSS can style inputs/buttons.
 */
function styleKlaviyoForm(form) {
  if (!form || form.classList.contains("duckfeet-klaviyo-form")) return;

  form.classList.add("duckfeet-klaviyo-form");

  form.querySelectorAll(".klaviyo-form-button").forEach((button, index) => {
    button.classList.add(
      index === 0 ? "duckfeet-klaviyo-form__submit" : "duckfeet-klaviyo-form__dismiss"
    );
  });
}

function observeKlaviyoForms() {
  document.querySelectorAll("form.klaviyo-form").forEach(styleKlaviyoForm);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches?.("form.klaviyo-form")) {
          styleKlaviyoForm(node);
        }

        node.querySelectorAll?.("form.klaviyo-form").forEach(styleKlaviyoForm);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeKlaviyoForms, { once: true });
} else {
  observeKlaviyoForms();
}

/**
 * Product description Read more / Read less toggle.
 */
class ProductDescriptionReadMore extends HTMLElement {
  connectedCallback() {
    this.preview = this.querySelector("[data-read-more-preview]");
    this.full = this.querySelector("[data-read-more-full]");
    this.toggle = this.querySelector("[data-read-more-toggle]");
    this.readMoreLabel = this.getAttribute("data-read-more-label") || "Read more";
    this.readLessLabel = this.getAttribute("data-read-less-label") || "Read less";
    this.expanded = false;

    this._onToggle = this._onToggle.bind(this);
    this.toggle?.addEventListener("click", this._onToggle);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener("click", this._onToggle);
  }

  _onToggle(event) {
    event.preventDefault();
    this.expanded = !this.expanded;

    if (this.preview) this.preview.hidden = this.expanded;
    if (this.full) this.full.hidden = !this.expanded;

    if (this.toggle) {
      this.toggle.setAttribute("aria-expanded", this.expanded ? "true" : "false");
      this.toggle.textContent = this.expanded ? this.readLessLabel : this.readMoreLabel;
    }
  }
}

if (!window.customElements.get("product-description-read-more")) {
  window.customElements.define("product-description-read-more", ProductDescriptionReadMore);
}

/**
 * Wrap size-chart tables so only the table scrolls horizontally.
 */
function wrapSizeChartTables(root = document) {
  root.querySelectorAll(".size-chart-drawer__content table").forEach((table) => {
    if (table.closest(".size-chart-table-scroll")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "size-chart-table-scroll";
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

/**
 * Size chart unit toggle (e.g. CM | INCH). The page content provides:
 *   <div class="size-chart-toogle"><span data-column="cm" class="active">CM</span><span data-column="in">IN</span></div>
 * and matching <th data-column="..."> headers. Only the selected unit column is shown. The HTML "active" class is the
 * default; a saved choice (cookie) overrides it when that unit exists in the chart.
 */
const SIZE_CHART_UNIT_COOKIE = "duckfeet_size_chart_unit";
const SIZE_CHART_TOGGLE_SELECTOR = ".size-chart-toogle, .size-chart-toggle";
const SIZE_CHART_OPTION_SELECTOR = ".size-chart-toogle [data-column], .size-chart-toggle [data-column]";
let sizeChartHeadingId = 0;

// AI_PENDING_REVIEW
function getSizeChartUnitCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${SIZE_CHART_UNIT_COOKIE}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
}

// AI_PENDING_REVIEW
function setSizeChartUnitCookie(unit) {
  const maxAge = 365 * 24 * 60 * 60;
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${SIZE_CHART_UNIT_COOKIE}=${encodeURIComponent(unit)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

// AI_PENDING_REVIEW
function applySizeChartUnit(toggle, unit) {
  const options = Array.from(toggle.querySelectorAll("[data-column]"));
  const units = options.map((option) => option.dataset.column);
  if (!units.includes(unit)) return false;

  options.forEach((option) => {
    const isActive = option.dataset.column === unit;
    option.classList.toggle("active", isActive);
    option.setAttribute("aria-pressed", isActive ? "true" : "false");
  });

  const scope = toggle.closest(".size-chart-drawer__content") || toggle.parentElement?.parentElement || document;

  scope.querySelectorAll("table").forEach((table) => {
    table.querySelectorAll("th[data-column]").forEach((header) => {
      if (!units.includes(header.dataset.column)) return;

      const hidden = header.dataset.column !== unit;
      const columnIndex = header.cellIndex;

      Array.from(table.rows).forEach((row) => {
        row.cells[columnIndex]?.classList.toggle("size-chart-column--hidden", hidden);
      });
    });
  });

  return true;
}

// AI_PENDING_REVIEW
function initSizeChartUnits(root = document) {
  const toggles = [];
  if (root instanceof Element && root.matches(SIZE_CHART_TOGGLE_SELECTOR)) toggles.push(root);
  root.querySelectorAll?.(SIZE_CHART_TOGGLE_SELECTOR).forEach((toggle) => toggles.push(toggle));

  const savedUnit = getSizeChartUnitCookie();

  toggles.forEach((toggle) => {
    toggle.setAttribute("role", "group");

    // Name the group from the nearby heading when present (page HTML varies by store/locale).
    if (!toggle.hasAttribute("aria-label") && !toggle.hasAttribute("aria-labelledby")) {
      const heading = toggle.closest(".size-chart-title")?.querySelector("h1, h2, h3, h4, h5, h6");
      if (heading) {
        if (!heading.id) {
          sizeChartHeadingId += 1;
          heading.id = `size-chart-unit-label-${sizeChartHeadingId}`;
        }
        toggle.setAttribute("aria-labelledby", heading.id);
      }
    }

    toggle.querySelectorAll("[data-column]").forEach((option) => {
      option.setAttribute("role", "button");
      option.tabIndex = 0;
    });

    if (savedUnit && applySizeChartUnit(toggle, savedUnit)) return;

    const defaultOption = toggle.querySelector("[data-column].active") || toggle.querySelector("[data-column]");
    if (defaultOption) applySizeChartUnit(toggle, defaultOption.dataset.column);
  });
}

// AI_PENDING_REVIEW
function selectSizeChartUnit(option) {
  const unit = option.dataset.column;
  if (!unit || option.classList.contains("active")) return;

  document.querySelectorAll(SIZE_CHART_TOGGLE_SELECTOR).forEach((toggle) => applySizeChartUnit(toggle, unit));
  setSizeChartUnitCookie(unit);
}

// AI_PENDING_REVIEW
function bindSizeChartUnitEvents() {
  document.addEventListener("click", (event) => {
    const option = event.target.closest?.(SIZE_CHART_OPTION_SELECTOR);
    if (!option) return;
    event.preventDefault();
    selectSizeChartUnit(option);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const option = event.target.closest?.(SIZE_CHART_OPTION_SELECTOR);
    if (!option) return;
    event.preventDefault();
    selectSizeChartUnit(option);
  });
}

function initSizeChartTables() {
  wrapSizeChartTables();
  initSizeChartUnits();
  bindSizeChartUnitEvents();

  document.addEventListener("toggle", (event) => {
    const drawer = event.target;
    if (!(drawer instanceof Element) || !drawer.classList.contains("size-chart-drawer")) return;
    if (!drawer.hasAttribute("open")) return;
    wrapSizeChartTables(drawer);
    initSizeChartUnits(drawer);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.matches?.(".size-chart-drawer, .size-chart-drawer__content") ||
          node.querySelector?.(".size-chart-drawer__content, .size-chart-drawer")
        ) {
          wrapSizeChartTables(node);
          initSizeChartUnits(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSizeChartTables, { once: true });
} else {
  initSizeChartTables();
}

/**
 * Swap size option labels between EU / UK / US using size_chart metaobject map.
 * Variant values stay Duckfeet (EU); only visible labels change.
 */
class SizeSystemPicker extends HTMLElement {
  connectedCallback() {
    this.map = this._normalizeMap(this._parseMap());
    this.baseSystem = this.getAttribute("data-base-system") || "duckfeet";
    this.baseLabel = this.getAttribute("data-base-label") || "EU";
    this.allowedSystems = this._parseAllowedSystems();
    this.systems = this._collectSystems();
    this._renderToggles();
    this.toggles = Array.from(this.querySelectorAll("[data-size-system]"));
    this.optionRoot = this.closest(".variant-picker__option");
    this.storageKey = "duckfeet_size_system";

    this._onToggle = this._onToggle.bind(this);
    this._onOptionChange = this._onOptionChange.bind(this);

    this.toggles.forEach((toggle) => toggle.addEventListener("click", this._onToggle));
    this.optionRoot?.addEventListener("change", this._onOptionChange);

    const saved = this._getSavedSystem() || this.baseSystem;
    this.setSystem(saved, { persist: false });
  }

  disconnectedCallback() {
    this.toggles.forEach((toggle) => toggle.removeEventListener("click", this._onToggle));
    this.optionRoot?.removeEventListener("change", this._onOptionChange);
  }

  _getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : "";
  }

  _setCookie(name, value, days = 365) {
    const maxAge = days * 24 * 60 * 60;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  }

  _getSavedSystem() {
    return this._getCookie(this.storageKey) || sessionStorage.getItem("duckfeet:size-system") || "";
  }

  _saveSystem(system) {
    this._setCookie(this.storageKey, system);
    try {
      sessionStorage.setItem("duckfeet:size-system", system);
    } catch (error) {
      // Ignore storage failures (private mode, quota, etc.)
    }
  }

  _parseMap() {
    try {
      return JSON.parse(this.getAttribute("data-size-map") || "{}");
    } catch (error) {
      return {};
    }
  }

  _parseAllowedSystems() {
    const raw = (this.getAttribute("data-allowed-systems") || "").trim();
    if (!raw) return null;

    const allowed = raw
      .split(/[,|]/)
      .map((item) => item.trim().toLowerCase())
      .filter(Boolean);

    return allowed.length ? allowed : null;
  }

  _isMetaKey(key) {
    return ["id", "handle", "type", "updated_at", "system", "admin_graphql_api_id"].includes(key);
  }

  _normalizeValue(value) {
    if (value == null) return "";
    if (typeof value === "object") {
      return value.value != null ? String(value.value).trim() : "";
    }
    return String(value).trim();
  }

  _normalizeMap(raw) {
    const map = {};

    Object.entries(raw || {}).forEach(([key, row]) => {
      if (!row || typeof row !== "object") return;

      const normalizedRow = {};
      Object.entries(row).forEach(([field, value]) => {
        if (this._isMetaKey(field)) return;
        normalizedRow[field] = this._normalizeValue(value);
      });

      map[String(key).trim()] = normalizedRow;
    });

    return map;
  }

  _isAllowedSystem(system) {
    if (!this.allowedSystems) return true;

    const normalized = String(system || "").trim().toLowerCase();
    return this.allowedSystems.some((allowed) => {
      if (allowed === normalized) return true;
      // Market metafield uses "eu" for the Duckfeet/EU base system
      if ((allowed === "eu" || allowed === "duckfeet") && (normalized === this.baseSystem || normalized === "duckfeet" || normalized === "eu")) {
        return true;
      }
      return false;
    });
  }

  _collectSystems() {
    const keys = new Set([this.baseSystem]);

    Object.values(this.map || {}).forEach((row) => {
      if (!row || typeof row !== "object") return;
      Object.keys(row).forEach((key) => {
        if (this._isMetaKey(key) || this._isHiddenSystem(key)) return;
        if (this._normalizeValue(row[key]) !== "") {
          keys.add(key);
        }
      });
    });

    let systems = [this.baseSystem, ...Array.from(keys).filter((system) => system !== this.baseSystem)];
    systems = systems.filter((system) => this._isAllowedSystem(system));

    // If market filter matched nothing, fall back to showing all (minus hidden)
    if (!systems.length) {
      systems = [this.baseSystem, ...Array.from(keys).filter((system) => system !== this.baseSystem)];
    }

    return systems;
  }

  _isHiddenSystem(system) {
    const normalized = String(system || "").trim().toLowerCase();
    return normalized === "cm" || normalized === "inch" || normalized === "inches";
  }

  _formatSystemLabel(system) {
    if (system === this.baseSystem) return this.baseLabel;
    return system.replace(/_/g, " ").toUpperCase();
  }

  _renderToggles() {
    const container = this.querySelector(".size-system-picker__toggles");
    if (!container) return;

    container.replaceChildren();

    if (this.systems.length < 2) {
      container.hidden = true;
      return;
    }

    container.hidden = false;

    this.systems.forEach((system, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = `size-system-picker__toggle${index === 0 ? " is-active" : ""}`;
      button.setAttribute("data-size-system", system);
      button.setAttribute("aria-pressed", index === 0 ? "true" : "false");
      button.textContent = this._formatSystemLabel(system);
      container.appendChild(button);
    });
  }

  _mapLabel(key, system) {
    if (!key) return "";
    const row = this.map[String(key).trim()];
    if (!row) return key;
    return row[system] || row[this.baseSystem] || key;
  }

  _onToggle(event) {
    const system = event.currentTarget.getAttribute("data-size-system");
    if (!system) return;
    this.setSystem(system);
  }

  _onOptionChange() {
    this._updateSelectedLabel(this.activeSystem || this.baseSystem);
  }

  setSystem(system, { persist = true } = {}) {
    const fallback = this.systems[0] || this.baseSystem;
    const nextSystem = this.systems.includes(system) ? system : fallback;
    this.activeSystem = nextSystem;

    if (persist) {
      this._saveSystem(nextSystem);
    }

    this.toggles.forEach((toggle) => {
      const isActive = toggle.getAttribute("data-size-system") === nextSystem;
      toggle.classList.toggle("is-active", isActive);
      toggle.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    const optionRoot = this.optionRoot || this;
    optionRoot.querySelectorAll("[data-size-key]").forEach((el) => {
      const key = el.getAttribute("data-size-key");
      const mapped = this._mapLabel(key, nextSystem);
      const label = el.querySelector("[data-size-label]");
      if (label) {
        label.textContent = mapped;
      }
    });

    this._updateSelectedLabel(nextSystem);
  }

  _updateSelectedLabel(system) {
    const optionRoot = this.optionRoot || this;
    const checked = optionRoot.querySelector("input[data-option-position]:checked");
    if (!checked) return;

    const optionEl =
      checked.closest("[data-size-key]") ||
      optionRoot.querySelector(`[data-size-key][for="${CSS.escape(checked.id)}"]`) ||
      checked.nextElementSibling;
    const key = optionEl?.getAttribute?.("data-size-key");
    if (!key) return;

    const originDisplay = this._mapLabel(key, this.baseSystem) || key;
    const mappedDisplay = this._mapLabel(key, system);

    optionRoot.querySelectorAll("[data-size-selected-origin]").forEach((el) => {
      if (el.querySelector(".text-subdued")) return;
      el.textContent = originDisplay;
    });

    optionRoot.querySelectorAll("[data-size-selected-label]").forEach((el) => {
      if (el.querySelector(".text-subdued")) return;
      el.textContent = mappedDisplay;
    });
  }
}

if (!window.customElements.get("size-system-picker")) {
  window.customElements.define("size-system-picker", SizeSystemPicker);
}

/**
 * Open Orbe geolocation modal (footer "Shipping to", etc.).
 */
function openOrbeGeolocationModal(trigger) {
  const headerGeo = document.querySelector(".header__icon_geolocation");
  const orbeTrigger = headerGeo?.querySelector("button[onclick], [onclick], button, a");

  if (orbeTrigger) {
    orbeTrigger.click();
    return;
  }

  if (window.orbito?.openModalWithoutRefresh) {
    window.lastModalTriggerButton = trigger || document.activeElement;
    window.orbito.openModalWithoutRefresh(true);
  }
}

function initOrbeGeolocationTriggers() {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-orbe-geolocation-trigger]");
    if (!trigger) return;

    event.preventDefault();
    openOrbeGeolocationModal(trigger);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOrbeGeolocationTriggers, { once: true });
} else {
  initOrbeGeolocationTriggers();
}

/**
 * Centered store-region popup: choose a region, then redirect immediately.
 */
class StoreRegionPopup extends NewsletterModal {
  _setInitialPosition() {
    this.style.top = "0px";
    this.style.right = "0px";
    this.style.bottom = "0px";
    this.style.left = "0px";
  }

  connectedCallback() {
    super.connectedCallback();

    this.shadowRoot
      ?.querySelector('[part="overlay"]')
      ?.addEventListener("click", (event) => event.stopImmediatePropagation(), {
        capture: true,
        signal: this._abortController.signal
      });

    if (this._initialized) return;
    this._initialized = true;

    this.cookieName = "duckfeet_store_region";
    this.persistChoice = this.hasAttribute("save-cookie-auto-redirect");
    this.form = this.querySelector("[data-store-region-form]");
    this.select = this.querySelector("[data-store-region-select]");
    this.regions = this._parseRegions();

    this._populateSelect();
    this._onSubmit = this._onSubmit.bind(this);
    this._onDismiss = this._onDismiss.bind(this);
    this.form?.addEventListener("submit", this._onSubmit);
    this.addEventListener("dialog:after-hide", this._onDismiss);

    if (this._maybeAutoRedirect()) return;

    // Theme editor: open only when this section is selected, not on every page load.
    if (Shopify?.designMode) return;
    if (this._hasCompletedChoice()) return;

    if (this.regions.length) {
      this._openTimeout = setTimeout(() => {
        if (!this._dismissed) this.show();
      }, this.apparitionDelay);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    clearTimeout(this._openTimeout);
  }

  // Close only via the X button — overlay / CookieScript / outside clicks must not dismiss it.
  _allowOutsideClickMouse() {
    return true;
  }

  _allowOutsideClickTouch() {
    return true;
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0, 10) * 1000;
  }

  _onDismiss() {
    this._dismissed = true;
    clearTimeout(this._openTimeout);
  }

  _getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : "";
  }

  _setCookie(name, value, days = 365) {
    const maxAge = days * 24 * 60 * 60;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  }

  _readStoredValue() {
    try {
      return this._getCookie(this.cookieName) || localStorage.getItem(this.cookieName) || "";
    } catch (error) {
      return this._getCookie(this.cookieName);
    }
  }

  _writeChoice(value) {
    const serialized = JSON.stringify(value);
    this._setCookie(this.cookieName, serialized);

    try {
      localStorage.setItem(this.cookieName, serialized);
    } catch (error) {
      // Ignore storage failures (private mode, quota, etc.)
    }
  }

  _getSavedChoice() {
    const raw = this._readStoredValue();
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      if (parsed?.redirect) return parsed;
    } catch (error) {
      // Legacy: cookie stored as a raw URL
      if (this._isSafeRedirect(raw)) return { redirect: raw };
    }

    return null;
  }

  _hasCompletedChoice() {
    return Boolean(this._getSavedChoice());
  }

  _saveChoice(destination) {
    this._writeChoice({
      region: destination.region,
      redirect: destination.redirect
    });
  }

  _findSavedDestination() {
    const saved = this._getSavedChoice();
    if (!saved?.redirect) return null;

    return (
      this.regions.find(
        (item) => this._urlsMatch(item.redirect, saved.redirect) || item.region === saved.region
      ) || null
    );
  }

  _hostname(url) {
    return new URL(url, window.location.origin).hostname.replace(/^www\./i, "").toLowerCase();
  }

  _normalizeUrl(url) {
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname.replace(/\/+$/, "") || "/";
    return `${parsed.protocol}//${this._hostname(parsed.href)}${pathname}`;
  }

  _urlsMatch(a, b) {
    try {
      return this._normalizeUrl(a) === this._normalizeUrl(b);
    } catch (error) {
      return a === b;
    }
  }

  _isCurrentDestination(url) {
    try {
      return this._urlsMatch(url, window.location.href);
    } catch (error) {
      return false;
    }
  }

  _isCurrentStore(url) {
    try {
      return this._hostname(url) === this._hostname(window.location.href);
    } catch (error) {
      return false;
    }
  }

  _maybeAutoRedirect() {
    if (!this.persistChoice || Shopify?.designMode) return false;

    const destination = this._findSavedDestination();
    if (!destination || !this._isSafeRedirect(destination.redirect)) return false;

    // Already on this page or this store: never navigate, never re-open the popup.
    if (this._isCurrentDestination(destination.redirect) || this._isCurrentStore(destination.redirect)) {
      return true;
    }

    window.location.replace(destination.redirect);
    return true;
  }

  _parseRegions() {
    const raw = (this.getAttribute("data-regions") || "").trim();
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];

      return parsed
        .map((item) => {
          if (!item || typeof item !== "object") return null;
          const region = String(item.region || item.label || "").trim();
          const redirect = String(item.redirect || item.url || "").trim();
          if (!region || !redirect) return null;
          return { region, redirect };
        })
        .filter(Boolean);
    } catch (error) {
      console.warn("Store region popup: invalid JSON", error);
      return [];
    }
  }

  _populateSelect() {
    if (!this.select) return;

    const placeholder = this.select.querySelector("option[disabled]");
    this.select.replaceChildren();
    if (placeholder) this.select.appendChild(placeholder);

    this.regions.forEach((item, index) => {
      const option = document.createElement("option");
      option.value = String(index);
      option.textContent = item.region;
      this.select.appendChild(option);
    });
  }

  _isSafeRedirect(url) {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (error) {
      return false;
    }
  }

  _onSubmit(event) {
    event.preventDefault();

    const index = this.select?.value;
    const destination = this.regions[index];
    if (!destination || !this._isSafeRedirect(destination.redirect)) return;

    this._saveChoice(destination);

    if (this._isCurrentDestination(destination.redirect)) {
      this.hide();
      return;
    }

    window.location.assign(destination.redirect);
  }
}

if (!window.customElements.get("store-region-popup")) {
  window.customElements.define("store-region-popup", StoreRegionPopup);
}

/**
 * GovX ID: open verify URL in a centered popup (matches app cart_drawer CTA behavior).
 */
document.addEventListener("click", (event) => {
  const link = event.target.closest('[data-action="govx-id-pop"]');
  if (!link) return;

  event.preventDefault();

  const width = 450;
  const height = 700;
  const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
  const dualScreenTop = window.screenTop ?? window.screenY ?? 0;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
  const left = viewportWidth / 2 - width / 2 + dualScreenLeft;
  const top = viewportHeight / 2 - height / 2 + dualScreenTop;

  window.open(
    link.href,
    "GOVX ID Authorization",
    `width=${width},height=${height},top=${top},left=${left}`
  );
});

export { DtailsCartTerms, NewsletterModal, LegalGuaranteePopup, ProductDescriptionReadMore, SizeSystemPicker, StoreRegionPopup, openOrbeGeolocationModal };
